import axios from "axios";
import { ARQUIVOS_GERAIS_FINANCAS_LIST, ARQUIVOS_GERAIS_FINANCAS_LIST_FAILED } from "./Events";
import { toDoWithForms, notifyApiError } from './utils';


export function list(filter) {
  return function (dispatch) {
    const request = axios.post(`/PublicArquivoGeralFinancas/List`, filter);

    request
      .then(response => {
        dispatch({ type: ARQUIVOS_GERAIS_FINANCAS_LIST, payload: response.data });
      })
      .catch((error) => {
        const message = notifyApiError(error, 'Não foi possível carregar os arquivos');
        dispatch({ type: ARQUIVOS_GERAIS_FINANCAS_LIST_FAILED, payload: message });
      });
  };
}

export function clearResults() {
  return function (dispatch) {
    dispatch({ type: ARQUIVOS_GERAIS_FINANCAS_LIST, payload: null });
  };
}

export function download(fileId) {
  return function (dispatch) {
    toDoWithForms( `/PublicArquivoGeralFinancas/Download?fileId=${fileId}`);
  }
}